import Megatron from '@ibibo/megatron';
import {PINCODE_API_URL} from '../../../verticals/onboarding/src/constants/index';

const getPincodeInfo = async (code) => {
  const pincodeApi = PINCODE_API_URL;
  const url = `${pincodeApi}${code}`;
  const response = await Megatron({
    name: 'Pincode Info Api',
    type: 'GET',
    url,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'charset=UTF-8'
    },
  });

  return response;
};

export default getPincodeInfo;
